// extracted by mini-css-extract-plugin
export default {"container":"UserFilter_container__hIzc4","label":"UserFilter_label__PJU4E"};